<template>
  <a-row :gutter="24" type="flex">

    <!-- Projects Table Column -->
    <a-col :span="24" class="mb-24">

      <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{padding: 0}">
        <template #title>
          <a-row type="flex" align="middle">
            <a-col :span="24" :md="12" class="top-left-header">
              <h5 class="font-semibold m-0">
                Leaderboard List
                <a-spin v-if="confirmLoading"/>
              </h5>
            </a-col>
            <a-col :span="24" :md="12" class="top-right-header">
              <a-button @click="manipulateModal = true; isUpdate = false">Score Manipulate</a-button>
            </a-col>
          </a-row>
        </template>
        <a-table :columns="columnData"
                 :data-source="scoreList"
                 :pagination="false">

          <template slot="name" slot-scope="text">
            <a>{{ text }}</a>
          </template>

          <template slot="updateBtn" slot-scope="row">
            <div>
              <a-button type="link" :data-id="row.key">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
                     @click="updateScore(row.details)">
                  <path class="fill-gray-7"
                        d="M13.5858 3.58579C14.3668 2.80474 15.6332 2.80474 16.4142 3.58579C17.1953 4.36683 17.1953 5.63316 16.4142 6.41421L15.6213 7.20711L12.7929 4.37868L13.5858 3.58579Z"/>
                  <path class="fill-gray-7"
                        d="M11.3787 5.79289L3 14.1716V17H5.82842L14.2071 8.62132L11.3787 5.79289Z"/>
                </svg>
              </a-button>
            </div>
          </template>
        </a-table>

        <div class="pagination">
          <a-pagination
              v-model:current="currentPage"
              :total="pagination.total"
              :page-size="20"
              :hideOnSinglePage="true"
              @change="onPageChange"
          />
        </div>
      </a-card>

    </a-col>
    <!-- / Projects Table Column -->

    <!--    Add New Category-->
    <a-modal
        v-model:manipulateModal="manipulateModal"
        title="Score Manipulate"
        :confirm-loading="confirmLoading"
        @ok="closeManipulateModal"
    >
      <div class="new-upload-data">
        <div>
          <label>User Name</label>
          <a-input v-model="userName" type="text" placeholder="user name" :disabled="isUpdate"/>
        </div>
        <div>
          <label>User Phone</label>
          <a-input v-model="userPhone" type="text" placeholder="user phone" :disabled="isUpdate"/>
        </div>
        <div class="tournament-score">
          <div>
            <label>Time Took</label>
            <a-input-number v-model="timeTook" type="text" placeholder="time took"/>
          </div>
          <div>
            <label>Tournament Score</label>
            <a-input-number v-model="gameScore" type="text" placeholder="tournament score"/>
          </div>
        </div>
        <div v-if="errorMsg.length" class="ant-btn-danger mt-5">{{ errorMsg }}</div>
      </div>
    </a-modal>
  </a-row>
</template>

<script>
import {sendRequest} from '@/http/axios.method';

const COLUMN_DATA = [
  {
    title: 'User Name',
    dataIndex: 'user_name',
    width: 200,
  },
  {
    title: 'Phone',
    dataIndex: 'phone',
    width: 200,
  },
  {
    title: 'Score',
    dataIndex: 'score',
    class: 'font-semibold text-muted',
  },
  {
    title: 'Action',
    scopedSlots: {customRender: 'updateBtn'},
    width: 200,
  },
];

export default {
  name: "Leaderboard",
  data() {
    return {
      config: {
        'Authorization': 'Bearer ' + this.$store.state.authUser.token
      },
      columnData: COLUMN_DATA,
      scoreList: [],
      tournamentId: this.$route.query.tournament_id,
      confirmLoading: false,
      currentPage: 1,
      pagination: {},
      manipulateModal: false,
      errorMsg: false,
      userName: '',
      userPhone: '',
      timeTook: 0,
      gameScore: 0,
      isUpdate: false,
    }
  },
  created() {
    this.getScoreList();
  },
  methods: {
    onPageChange() {
      this.getScoreList()
    },
    getScoreList() {
      this.confirmLoading = true;
      let data = {
        tournament_id: this.tournamentId,
      }
      sendRequest('get', 'admin/leaderboard-scores', data, this.config)
          .then(response => {
            this.confirmLoading = false;
            if (response.success) {
              let data = response.data.score_list
              this.scoreList = data.map(function (content, label) {
                return {
                  key: label + 1,
                  id: content.user_id,
                  user_name: content.user.name,
                  phone: content.user.phone,
                  score: content.score,
                  details: content
                };
              });
            } else {
              if (response.status_code === 401) {
                this.$store.dispatch('logout');
                this.$router.push('/login');
              }
            }
          })
          .catch(() => {
            this.confirmLoading = false;
          })
          .finally(() => {
            this.confirmLoading = false;
          })
    },
    updateScore(details) {
      this.userName = details.user.name;
      this.userPhone = details.user.phone;
      this.gameScore = details.score;
      this.timeTook = details.time_took;
      this.isUpdate = true;
      this.manipulateModal = true;
    },
    closeManipulateModal() {
      this.errorMsg = false;
      if (this.validateNewScore()) {
        let data = {
          tournament_id: this.tournamentId,
          user_name: this.userName,
          user_phone: this.userPhone,
          time_took: this.timeTook,
          game_score: this.gameScore
        }

        sendRequest('post', 'admin/leaderboard-new-score', data, this.config)
            .then(response => {
              this.confirmLoading = false;
              if (response.success) {
                this.userName = '';
                this.userPhone = '';
                this.timeTook = 0;
                this.gameScore = 0;
                this.isUpdate = false;
                window.location.reload()
              } else {
                if (response.status_code === 401) {
                  this.$store.dispatch('logout');
                  this.$router.push('/login');
                }
              }
            })
            .catch(() => {
              this.confirmLoading = false;
            })
            .finally(() => {
              this.confirmLoading = false;
            })
      }

    },

    validateNewScore() {
      if (this.userName.length === 0) {
        this.errorMsg = 'Please provide user name';
        return false;
      }
      if (this.userPhone.length === 0) {
        this.errorMsg = 'Please provide user phone';
        return false;
      }

      return true;
    }
  }
}
</script>

<style lang="scss" scoped>
.tournament-score {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 11px;

  label {
    margin-right: 8px;
  }
}
</style>
